import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import {
  PortableText,
  PortableTextTypeComponentProps,
} from "@portabletext/react"
import Icon from "Components/Icon/Icon"

interface INoteProps {
  heading?: any[]
  blockContent?: any[]
  collapsed?: boolean
  id?: string
}

export default function Note(
  props: PortableTextTypeComponentProps<INoteProps>
) {
  const { id, collapsed, blockContent, heading } = props.value

  const PortableTextHeading = <PortableText value={heading} />
  const children = blockContent ? <PortableText value={blockContent} /> : null

  return (
    <StyledAccordion defaultExpanded={collapsed ? false : true}>
      <StyledAccordionSummary id={id} expandIcon={<Icon name="expandMore" />}>
        <Typography component="span" variant="h6">
          {PortableTextHeading}
        </Typography>
      </StyledAccordionSummary>
      <AccordionDetails>
        <Typography variant="body2" component="span">
          {children}
        </Typography>
      </AccordionDetails>
    </StyledAccordion>
  )
}

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.opacityBackground,
  "& .MuiAccordionSummary-root": {
    minHeight: "min-content",
    maxHeight: "min-content",
    "&.Mui-expanded": {
      minHeight: "min-content",
      maxHeight: "min-content",
    },
  },
}))

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.opacityBackground,
}))
